/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
import _crypto from 'crypto';
import { btoa, atob } from './helpers';

export default class CustomEncryption {
  // aes encrypt
  encryption(text, forgotPassword = false, masterkey = '') {
    if (masterkey != '') {
      masterkey = atob(masterkey);
    }

    if (forgotPassword && masterkey == '') {
      masterkey = localStorage.getItem('fp_qram_key');
    } else if (!forgotPassword && masterkey == '') {
      masterkey = localStorage.getItem('qram_key');
    }

    const secret = _crypto.createHash('sha256').update(masterkey).digest();

    const textToEncrypt = text;
    const encryptionMethod = 'AES-256-GCM';
    const iv = masterkey.substring(0, 12);

    const encryptor = _crypto.createCipheriv(encryptionMethod, secret, iv);

    const final =
      encryptor.update(textToEncrypt, 'utf8', 'base64') +
      encryptor.final('base64');

    const buff = Buffer.from(encryptor.getAuthTag());
    const base64data = buff.toString('base64');
    const output = btoa(iv) + base64data + btoa(final);

    return output;
  }

  decryption({
    enc = null,
    final = null,
    iv = null,
    authtag = null,
    masterkey = null,
  }) {
    if (enc != null) {
      final = enc.substring(0, 600);
      iv = enc.substring(600, 612);
      authtag = enc.substring(612, 636);
    }
    masterkey = atob(masterkey);
    const encryptionMethod = 'AES-256-GCM';
    const secret = _crypto.createHash('sha256').update(masterkey).digest();

    const decipher = _crypto.createDecipheriv(encryptionMethod, secret, iv);
    decipher.setAuthTag(authtag);

    const str = decipher.update(final, 'base64', 'utf8');

    return str;
  }

  // public encrypt
  encrypt(text = '', payload = '', extra = '') {
    const accessKey = atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3));
    let data;
    if (text == '') {
      data = accessKey + payload;
    } else {
      data = text;
    }

    const ecryptedData = _crypto.publicEncrypt(
      {
        key: extra,
        padding: _crypto.constants.RSA_PKCS1_OAEP_PADDING,
        oaepHash: 'sha256',
      },
      Buffer.from(data)
    );

    return ecryptedData.toString('base64');
  }

  // public decrypt
  decrypt(text, save = false, forgotPassword = false, extra = '') {
    try {
      const decryptedData = _crypto.publicDecrypt(
        extra,
        Buffer.from(text, 'base64')
      );
      if (save && forgotPassword) {
        localStorage.setItem('fp_qram_key', decryptedData.toString());
      } else if (save) {
        localStorage.setItem('qram_key', decryptedData.toString());
      }
      return decryptedData.toString();
    } catch (err) {
      return false;
    }
  }
}
